"use strict";
exports.__esModule = true;
exports.SvgArrowAction = void 0;
var tslib_1 = require("tslib");
/**
 * This file is generated from 'npm run build-svg'. Any changes should be made to the
 * template in .svgrrc.js or to the source SVG in src/icons/svg.
 **/
var react_1 = tslib_1.__importDefault(require("react"));
exports.SvgArrowAction = function (props) { return (react_1["default"].createElement("svg", tslib_1.__assign({ viewBox: "0 0 24 24", fill: "none" }, props),
    react_1["default"].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4.75 6.75a.75.75 0 01.75.75c0 1.76.552 2.893 1.296 3.592.756.709 1.796 1.048 2.907 1.048H16.9l-2.378-2.308a.75.75 0 011.044-1.076l3.706 3.596a.75.75 0 010 1.077l-3.72 3.61a.75.75 0 11-1.044-1.077L16.9 13.64H9.703c-1.405 0-2.841-.43-3.933-1.454C4.668 11.152 4 9.591 4 7.5a.75.75 0 01.75-.75z", fill: "currentColor" }))); };
//# sourceMappingURL=ArrowAction.js.map